export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/presentation_design.cb8e778.svg";